import { render, staticRenderFns } from "./VCar.vue?vue&type=template&id=4e673175&scoped=true&"
import script from "./VCar.vue?vue&type=script&lang=js&"
export * from "./VCar.vue?vue&type=script&lang=js&"
import style0 from "./VCar.vue?vue&type=style&index=0&id=4e673175&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e673175",
  null
  
)

export default component.exports